import { IS_RTL_DIRECTION } from 'consts'
import { COLORS } from 'consts/colors'

import styled, { css } from 'styled-components'
import { disableSomeContentStyles } from 'styles/mixins'

export const UndoRedoWrapper = styled.div<{ $isDisable: boolean }>`
  display: flex;
  align-items: center;

  gap: 8px;
  height: 100%;
  ${IS_RTL_DIRECTION
    ? css`
        flex-direction: row-reverse;
        justify-content: flex-end;
      `
    : ''}

  ${props => props.$isDisable && disableSomeContentStyles()}
`

export const UndoRedoAction = styled.div<{
  $isActive: boolean
}>`
  display: flex;
  align-items: center;
  ${props => {
    if (props.$isActive) {
      return css`
        cursor: pointer;
        svg {
          path {
            fill: ${COLORS.primaryDark};
          }
        }
      `
    }
    return css`
      cursor: not-allowed;
      pointer-events: none;
    `
  }}
`
